import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiX, FiTrash2, FiShoppingBag, FiArrowRight } from 'react-icons/fi';
import { useCartStore } from '../store/cartStore';
import './CartDrawer.css';

function CartDrawer({ open, onClose }) {
  const { items, updateCartItem, removeFromCart, getCartTotal } = useCartStore();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const handleQty = async (item, delta) => {
    const next = item.quantity + delta;
    if (next < 1) await removeFromCart(item.id);
    else await updateCartItem(item.id, next);
  };

  const subtotal = getCartTotal();
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <>
      <div className={`cart-overlay ${open ? 'open' : ''}`} onClick={onClose} />

      <div className={`cart-drawer ${open ? 'open' : ''}`}>

        {/* Header */}
        <div className="cd-header">
          <div className="cd-header-left">
            <div className="cd-header-icon"><FiShoppingBag size={18} /></div>
            <div>
              <h2>Your Cart</h2>
              {count > 0 && <span className="cd-count">{count} {count === 1 ? 'item' : 'items'}</span>}
            </div>
          </div>
          <button className="cd-close" onClick={onClose} aria-label="Close">
            <FiX size={18} />
          </button>
        </div>

        {/* Body */}
        {items.length === 0 ? (
          <div className="cd-empty">
            <div className="cd-empty-icon"><FiShoppingBag size={44} /></div>
            <h3>Your cart is empty</h3>
            <p>Add some products to get started</p>
            <Link to="/products" className="cd-empty-btn" onClick={onClose}>
              Browse Products <FiArrowRight size={14} />
            </Link>
          </div>
        ) : (
          <>
            <div className="cd-items">
              {items.map((item, i) => {
                const price = (item.product?.discount_price && item.product?.discount_active !== false ? item.product.discount_price : null) || item.product?.price || 0;
                const orig  = item.product?.price || 0;
                const hasDiscount = item.product?.discount_price && item.product?.discount_active !== false;
                return (
                  <div key={item.id} className="cd-item" style={{ '--idx': i }}>
                    <div className="cd-item-img-wrap">
                      <img
                        src={item.product?.image_url || 'https://placehold.co/80x80?text=?'}
                        alt={item.product?.name}
                        className="cd-item-img"
                      />
                    </div>

                    <div className="cd-item-body">
                      <p className="cd-item-name">{item.product?.name}</p>
                      <div className="cd-item-prices">
                        <span className="cd-item-price">Rs {price.toFixed(0)}</span>
                        {hasDiscount && <span className="cd-item-orig">Rs {orig.toFixed(0)}</span>}
                      </div>

                      <div className="cd-qty-row">
                        <div className="cd-qty">
                          <button className="cd-qty-btn" onClick={() => handleQty(item, -1)}>−</button>
                          <span className="cd-qty-val">{item.quantity}</span>
                          <button className="cd-qty-btn" onClick={() => handleQty(item, +1)}>+</button>
                        </div>
                        <span className="cd-line-total">Rs {(price * item.quantity).toFixed(0)}</span>
                      </div>
                    </div>

                    <button className="cd-remove" onClick={() => removeFromCart(item.id)} aria-label="Remove">
                      <FiTrash2 size={14} />
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div className="cd-footer">
              <div className="cd-subtotal-row">
                <span className="cd-subtotal-label">Subtotal</span>
                <span className="cd-subtotal-val">Rs {subtotal.toFixed(0)}</span>
              </div>
              <button className="cd-checkout-btn" onClick={() => { onClose(); navigate('/checkout'); }}>
                Checkout <FiArrowRight size={16} />
              </button>
              <button className="cd-continue-btn" onClick={onClose}>Continue Shopping</button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default CartDrawer;
